export const HOST_ORDER_LIST = "HOST_ORDER_LIST"
export const HOST_ORDER_LIST_SUCCESSFUL = "HOST_ORDER_LIST_SUCCESSFUL"
export const HOST_ORDER_LIST_FAILED = "HOST_ORDER_LIST_FAILED"